export function formatFileSize(bytes) {
  const units = ["B", "KB", "MB", "GB", "TB"];
  let unitIndex = 0;

  while (bytes >= 1024 && unitIndex < units.length - 1) {
    bytes /= 1024;
    unitIndex++;
  }

  return `${bytes.toFixed(1)} ${units[unitIndex]}`;
}
export function getFileExtension(filename) {
  return filename.split(".").pop().toLowerCase();
}
export function truncateFileName(text, startChars, endChars) {
  const totalChars = startChars + endChars;

  if (text.length <= totalChars) {
    return text;
  }

  const start = text.substring(0, startChars);
  const end = text.substring(text.length - endChars);

  return `${start}...${end}`;
}
export const checkResponse = (r) => {
  if (r) {
    return !r?.errorCode;
  } else {
    return false;
  }
};

export const isEnableCapcha = () => {
  const status = getEnvVariable("REACT_APP_RECAPCHA_STATUS");
  if (status) {
    if (status === "off") return false;
    if (status === "on") return true;
  } else {
    return false;
  }
};

export const areAbsolutelyEqual = (a, b) =>
  a?.normalize("NFC") === b?.normalize("NFC");

export const getEnvVariable = (key, defaultValue = "") => {
  if (window._env_ && window._env_[key] !== undefined) {
    return window._env_[key];
  }
  return process.env[key] || defaultValue;
};
